import React from 'react';
import type { GroupBase, MultiValueGenericProps } from 'react-select';
import type { OptionType } from '../types';
import { getMultiSelectDisplayLabel } from '../utils/getMultiSelectDisplayLabel';
import CloseIcon from '/public/icons/close-tiny.svg';

type CustomMultiValueProps<T extends OptionType> = MultiValueGenericProps<T, true, GroupBase<T>> & {
  removeProps: React.HTMLAttributes<HTMLElement>;
  multiValueLabel?: React.ReactNode | string;
};

export const CustomMultiValue = <T extends OptionType>(props: CustomMultiValueProps<T>) => {
  const { data, removeProps } = props;
  return (
    <div className="flex items-center gap-1 bg-[#6993FF24] border border-blue-200 rounded-[4px] text-blue-800 px-[6px] py-[2px] mr-2">
      {data.icon && <span>{data.icon}</span>}
      <span className="text-body-regular text-black">{getMultiSelectDisplayLabel(data)}</span>
      <button
        className="flex items-center cursor-pointer ml-1"
        {...removeProps}
        tabIndex={0}
        role="button"
        type="button"
        aria-label="Remove"
      >
        <CloseIcon className="w-6 h-6" />
      </button>
    </div>
  );
};